import { FC } from 'react';

import { GameButton, HelpComponentWrapper, HelpText, Icons, HelpChapterProps } from '@pp/core';
import { InlineRecentResultsConnected } from '../../recentResults';

export const HelpChapterLastWinningSymbols: FC<HelpChapterProps> = ({ content }) => {
  if (!content) return null;
  return (
    <div>
      <p>
        <HelpText>{String(content.lastWinningSymbols)}</HelpText>
      </p>
      <HelpComponentWrapper  style={{marginTop: 'var(--core-spacing-regular)'}}>
        <InlineRecentResultsConnected explicitCount={12}/>
      </HelpComponentWrapper>
      <p>
        <HelpText>{String(content.winningSymbolsOrder)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.statistics)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <GameButton icon={Icons.Statistics} border />
      </HelpComponentWrapper>
    </div>
  );
};
